const KM_TO_MILE = 0.621371

export const kmToMileConverterWithDecimals = (distanceInKm: number | undefined, decimals: number = 0): number =>
  distanceInKm ? parseFloat((distanceInKm * KM_TO_MILE).toFixed(decimals)) : 0

export const kmToMileConverter = (distanceInKm: number | undefined): number =>
  distanceInKm ? distanceInKm * KM_TO_MILE : 0
